/* src/app/shared/components/modal-base/modal-base.component.scss */
:host ::ng-deep bfm-accounts-modal {
  --accounts-modal-width: 1280px;
  --accounts-modal-table-height: 400px;
  --accounts-modal-columns: 1fr 1fr 2fr 2fr 2fr 2fr 2fr;
  --accounts-modal-header-bg: var(--cds-background-accent);
  --accounts-modal-row-bg-even: var(--cds-background-accent);
  gap: 22px;
  padding: 10px 30px;
}
:host ::ng-deep bfm-accounts-modal .default-flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
:host ::ng-deep bfm-accounts-modal .default-flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
:host ::ng-deep bfm-accounts-modal .default-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
:host ::ng-deep bfm-accounts-modal .default-flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
:host ::ng-deep bfm-accounts-modal .default-flex-column {
  display: flex;
  flex-flow: column;
}
:host ::ng-deep bfm-accounts-modal .default-flex-stretch {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  align-content: stretch;
}
:host ::ng-deep bfm-accounts-modal .rounded-circle {
  border-radius: 50%;
}
:host ::ng-deep bfm-accounts-modal h1,
:host ::ng-deep bfm-accounts-modal h2,
:host ::ng-deep bfm-accounts-modal h3,
:host ::ng-deep bfm-accounts-modal h4,
:host ::ng-deep bfm-accounts-modal h5,
:host ::ng-deep bfm-accounts-modal h6,
:host ::ng-deep bfm-accounts-modal label,
:host ::ng-deep bfm-accounts-modal p,
:host ::ng-deep bfm-accounts-modal b,
:host ::ng-deep bfm-accounts-modal small,
:host ::ng-deep bfm-accounts-modal span,
:host ::ng-deep bfm-accounts-modal strong {
  margin: 0px;
  -webkit-font-smoothing: antialiased;
}
:host ::ng-deep bfm-accounts-modal h1.cds-required::after,
:host ::ng-deep bfm-accounts-modal h2.cds-required::after,
:host ::ng-deep bfm-accounts-modal h3.cds-required::after,
:host ::ng-deep bfm-accounts-modal h4.cds-required::after,
:host ::ng-deep bfm-accounts-modal h5.cds-required::after,
:host ::ng-deep bfm-accounts-modal h6.cds-required::after,
:host ::ng-deep bfm-accounts-modal label.cds-required::after,
:host ::ng-deep bfm-accounts-modal p.cds-required::after,
:host ::ng-deep bfm-accounts-modal b.cds-required::after,
:host ::ng-deep bfm-accounts-modal small.cds-required::after,
:host ::ng-deep bfm-accounts-modal span.cds-required::after,
:host ::ng-deep bfm-accounts-modal strong.cds-required::after {
  font-family: var(--cds-font-family);
  font-size: inherit;
  font-weight: inherit;
  color: var(--cds-danger-500);
  line-height: inherit;
  content: "*";
}
:host ::ng-deep bfm-accounts-modal h1[class^=c-],
:host ::ng-deep bfm-accounts-modal h2[class^=c-],
:host ::ng-deep bfm-accounts-modal h3[class^=c-],
:host ::ng-deep bfm-accounts-modal h4[class^=c-],
:host ::ng-deep bfm-accounts-modal h5[class^=c-],
:host ::ng-deep bfm-accounts-modal h6[class^=c-],
:host ::ng-deep bfm-accounts-modal label[class^=c-],
:host ::ng-deep bfm-accounts-modal p[class^=c-],
:host ::ng-deep bfm-accounts-modal b[class^=c-],
:host ::ng-deep bfm-accounts-modal small[class^=c-],
:host ::ng-deep bfm-accounts-modal span[class^=c-],
:host ::ng-deep bfm-accounts-modal strong[class^=c-] {
  color: var(--color);
}
:host ::ng-deep bfm-accounts-modal b,
:host ::ng-deep bfm-accounts-modal strong,
:host ::ng-deep bfm-accounts-modal span {
  font-family: var(--cds-font-family);
}
:host ::ng-deep bfm-accounts-modal h1 {
  font-family: var(--cds-font-family);
  font-size: 30px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host ::ng-deep bfm-accounts-modal h2 {
  font-family: var(--cds-font-family);
  font-size: 24px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host ::ng-deep bfm-accounts-modal h3 {
  font-family: var(--cds-font-family);
  font-size: 22px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host ::ng-deep bfm-accounts-modal h4 {
  font-family: var(--cds-font-family);
  font-size: 20px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host ::ng-deep bfm-accounts-modal h5 {
  font-family: var(--cds-font-family);
  font-size: 18px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host ::ng-deep bfm-accounts-modal h6 {
  font-family: var(--cds-font-family);
  font-size: 16px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host ::ng-deep bfm-accounts-modal p {
  font-family: var(--cds-font-family);
  font-size: 14px;
  font-weight: normal;
  color: var(--cds-text-medium);
  line-height: 1;
}
:host ::ng-deep bfm-accounts-modal p.bold {
  font-weight: bold;
}
:host ::ng-deep bfm-accounts-modal label {
  font-family: var(--cds-font-family);
  font-size: 14px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host ::ng-deep bfm-accounts-modal small {
  font-family: var(--cds-font-family);
  font-size: 12px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host ::ng-deep bfm-accounts-modal .accounts-modal-header {
  justify-content: space-between;
  gap: 0;
  width: 100%;
  padding: 0;
  color: var(--cds-primary-500);
}
:host ::ng-deep bfm-accounts-modal .accounts-modal-header__text {
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-direction: row;
  align-items: baseline;
  gap: 8px;
  font-weight: 500;
}
:host ::ng-deep bfm-accounts-modal .accounts-modal-header__title {
  font-family: var(--cds-font-family);
  font-size: 22px;
  font-weight: 700;
  color: var(--cds-primary-500);
  line-height: 1;
}
:host ::ng-deep bfm-accounts-modal .accounts-modal-header__subtitle {
  font-size: inherit;
  font-weight: 500;
  line-height: inherit;
  color: var(--cds-primary-500);
  gap: 8px;
}
:host ::ng-deep bfm-accounts-modal bfm-accounts-modal-icon {
  font-size: var(--cds-icon-font-size, 20px);
}
:host ::ng-deep bfm-accounts-modal .info-icon {
  width: auto;
  height: auto;
}
:host ::ng-deep bfm-accounts-modal .info-icon bfm-accounts-modal-icon {
  margin: 0;
  color: inherit;
}
:host ::ng-deep bfm-accounts-modal .accounts-modal-connect-button {
  width: 100%;
  background: var(--cds-primary-500);
  border-color: var(--cds-primary-500);
  color: var(--cds-primary-contrast);
}
:host ::ng-deep bfm-accounts-modal .accounts-modal-content {
  gap: 22px;
  padding: 0;
}
:host ::ng-deep bfm-accounts-modal .accounts-info-row {
  align-items: flex-end;
  gap: 0;
}
:host ::ng-deep bfm-accounts-modal .accounts-totals {
  align-self: flex-start;
  align-items: center;
  gap: 15px;
}
:host ::ng-deep bfm-accounts-modal .accounts-total {
  gap: 0;
}
:host ::ng-deep bfm-accounts-modal .accounts-total__label {
  font-family: var(--cds-font-family);
  font-size: 12px;
  font-weight: 400;
  color: var(--cds-text-light);
  line-height: 1.5;
}
:host ::ng-deep bfm-accounts-modal .accounts-total__value {
  font-family: var(--cds-font-family);
  font-size: 24px;
  font-weight: normal;
  color: var(--cds-primary-500);
  line-height: 1;
  padding-top: 5px;
  gap: 0;
}
:host ::ng-deep bfm-accounts-modal .accounts-total__value bfm-accounts-modal-icon {
  margin-right: 5px;
  color: var(--cds-secondary-500);
}
:host ::ng-deep bfm-accounts-modal .accounts-total[data-test=total-blocked] .accounts-total__value {
  color: var(--cds-secondary-500);
}
:host ::ng-deep bfm-accounts-modal .accounts-search-row {
  flex: none;
}
:host ::ng-deep bfm-accounts-modal .accounts-search {
  flex: none;
}
:host ::ng-deep bfm-accounts-modal .accounts-search input {
  --font-size: 12px;
  width: 360px;
  padding: 0px 32px;
}
:host ::ng-deep bfm-accounts-modal .accounts-search__icon {
  top: 6px;
  right: initial;
  left: 4px;
  font-size: 14px;
}
:host ::ng-deep bfm-accounts-modal .accounts-modal-search-button {
  width: 90px;
  background: transparent;
  border-color: var(--cds-primary-500);
  color: var(--cds-primary-500);
}
:host ::ng-deep bfm-accounts-modal .accounts-modal-search-button:hover {
  background: transparent;
  border-color: var(--cds-primary-500);
  color: var(--cds-primary-500);
}
:host ::ng-deep bfm-accounts-modal .accounts-table {
  margin-bottom: 24px;
  border: none;
  border-radius: 0;
  background: transparent;
}
:host ::ng-deep bfm-accounts-modal .accounts-table__row {
  height: 72px;
  min-height: 72px;
  padding: 5px 16px;
  border-bottom: 1px solid var(--cds-background-default);
}
:host ::ng-deep bfm-accounts-modal .accounts-table__header {
  border-bottom: 1px solid var(--cds-border);
}
:host ::ng-deep bfm-accounts-modal .accounts-table__header .accounts-table__cell {
  font-family: var(--cds-font-family);
  font-size: 14px;
  font-weight: 600;
  color: var(--cds-text-strong);
  line-height: 1.3;
  height: inherit;
}
:host ::ng-deep bfm-accounts-modal .accounts-table__header .accounts-table__cell span {
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
:host ::ng-deep bfm-accounts-modal .accounts-table__header .accounts-table__cell.clickable:hover {
  background-color: var(--cds-header-accent);
}
:host ::ng-deep bfm-accounts-modal .accounts-table__header .accounts-table__cell .click-icon {
  margin-left: 5px;
}
:host ::ng-deep bfm-accounts-modal .accounts-table__row--body:nth-of-type(even) {
  border-top: 1px solid var(--cds-border);
  border-bottom: 1px solid var(--cds-border);
}
:host ::ng-deep bfm-accounts-modal .accounts-table__cell {
  padding: 0;
}
:host ::ng-deep bfm-accounts-modal .accounts-table__cell:not(:first-child) {
  padding-left: 10px;
}
:host ::ng-deep bfm-accounts-modal .available_balance,
:host ::ng-deep bfm-accounts-modal .blocked_balance {
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  white-space: normal;
}
:host ::ng-deep bfm-accounts-modal .available_balance {
  color: var(--cds-primary-500);
}
:host ::ng-deep bfm-accounts-modal .blocked_balance {
  color: var(--cds-secondary-500);
}
:host ::ng-deep bfm-accounts-modal .available_balance.expense,
:host ::ng-deep bfm-accounts-modal .blocked_balance.expense {
  color: var(--cds-expense);
}
:host ::ng-deep bfm-accounts-modal .name input {
  height: var(--height);
}
:host ::ng-deep bfm-accounts-modal .bank-logo {
  width: 37px;
  height: 37px;
  margin-top: 5px;
}
:host ::ng-deep bfm-accounts-modal img.no-padding {
  margin: 0px 0px 3px 3px;
}
:host ::ng-deep bfm-cash-flow-modal {
}
:host ::ng-deep bfm-cash-flow-modal .default-flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
:host ::ng-deep bfm-cash-flow-modal .default-flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
:host ::ng-deep bfm-cash-flow-modal .default-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
:host ::ng-deep bfm-cash-flow-modal .default-flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
:host ::ng-deep bfm-cash-flow-modal .default-flex-column {
  display: flex;
  flex-flow: column;
}
:host ::ng-deep bfm-cash-flow-modal .default-flex-stretch {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  align-content: stretch;
}
:host ::ng-deep bfm-cash-flow-modal .rounded-circle {
  border-radius: 50%;
}
:host ::ng-deep bfm-cash-flow-modal h1,
:host ::ng-deep bfm-cash-flow-modal h2,
:host ::ng-deep bfm-cash-flow-modal h3,
:host ::ng-deep bfm-cash-flow-modal h4,
:host ::ng-deep bfm-cash-flow-modal h5,
:host ::ng-deep bfm-cash-flow-modal h6,
:host ::ng-deep bfm-cash-flow-modal label,
:host ::ng-deep bfm-cash-flow-modal p,
:host ::ng-deep bfm-cash-flow-modal b,
:host ::ng-deep bfm-cash-flow-modal small,
:host ::ng-deep bfm-cash-flow-modal span,
:host ::ng-deep bfm-cash-flow-modal strong {
  margin: 0px;
  -webkit-font-smoothing: antialiased;
}
:host ::ng-deep bfm-cash-flow-modal h1.cds-required::after,
:host ::ng-deep bfm-cash-flow-modal h2.cds-required::after,
:host ::ng-deep bfm-cash-flow-modal h3.cds-required::after,
:host ::ng-deep bfm-cash-flow-modal h4.cds-required::after,
:host ::ng-deep bfm-cash-flow-modal h5.cds-required::after,
:host ::ng-deep bfm-cash-flow-modal h6.cds-required::after,
:host ::ng-deep bfm-cash-flow-modal label.cds-required::after,
:host ::ng-deep bfm-cash-flow-modal p.cds-required::after,
:host ::ng-deep bfm-cash-flow-modal b.cds-required::after,
:host ::ng-deep bfm-cash-flow-modal small.cds-required::after,
:host ::ng-deep bfm-cash-flow-modal span.cds-required::after,
:host ::ng-deep bfm-cash-flow-modal strong.cds-required::after {
  font-family: var(--cds-font-family);
  font-size: inherit;
  font-weight: inherit;
  color: var(--cds-danger-500);
  line-height: inherit;
  content: "*";
}
:host ::ng-deep bfm-cash-flow-modal h1[class^=c-],
:host ::ng-deep bfm-cash-flow-modal h2[class^=c-],
:host ::ng-deep bfm-cash-flow-modal h3[class^=c-],
:host ::ng-deep bfm-cash-flow-modal h4[class^=c-],
:host ::ng-deep bfm-cash-flow-modal h5[class^=c-],
:host ::ng-deep bfm-cash-flow-modal h6[class^=c-],
:host ::ng-deep bfm-cash-flow-modal label[class^=c-],
:host ::ng-deep bfm-cash-flow-modal p[class^=c-],
:host ::ng-deep bfm-cash-flow-modal b[class^=c-],
:host ::ng-deep bfm-cash-flow-modal small[class^=c-],
:host ::ng-deep bfm-cash-flow-modal span[class^=c-],
:host ::ng-deep bfm-cash-flow-modal strong[class^=c-] {
  color: var(--color);
}
:host ::ng-deep bfm-cash-flow-modal b,
:host ::ng-deep bfm-cash-flow-modal strong,
:host ::ng-deep bfm-cash-flow-modal span {
  font-family: var(--cds-font-family);
}
:host ::ng-deep bfm-cash-flow-modal h1 {
  font-family: var(--cds-font-family);
  font-size: 30px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host ::ng-deep bfm-cash-flow-modal h2 {
  font-family: var(--cds-font-family);
  font-size: 24px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host ::ng-deep bfm-cash-flow-modal h3 {
  font-family: var(--cds-font-family);
  font-size: 22px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host ::ng-deep bfm-cash-flow-modal h4 {
  font-family: var(--cds-font-family);
  font-size: 20px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host ::ng-deep bfm-cash-flow-modal h5 {
  font-family: var(--cds-font-family);
  font-size: 18px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host ::ng-deep bfm-cash-flow-modal h6 {
  font-family: var(--cds-font-family);
  font-size: 16px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host ::ng-deep bfm-cash-flow-modal p {
  font-family: var(--cds-font-family);
  font-size: 14px;
  font-weight: normal;
  color: var(--cds-text-medium);
  line-height: 1;
}
:host ::ng-deep bfm-cash-flow-modal p.bold {
  font-weight: bold;
}
:host ::ng-deep bfm-cash-flow-modal label {
  font-family: var(--cds-font-family);
  font-size: 14px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host ::ng-deep bfm-cash-flow-modal small {
  font-family: var(--cds-font-family);
  font-size: 12px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host ::ng-deep bfm-cash-flow-modal ::ng-deep {
  padding: 26px;
  background-color: var(--cds-background-main);
}
:host ::ng-deep bfm-cash-flow-modal ::ng-deep .modal-container .subtitle {
  font-size: 18px !important;
  font-weight: 600 !important;
  color: var(--cds-text-strong) !important;
}
:host ::ng-deep bfm-cash-flow-modal ::ng-deep .modal-container fieldset label {
  font-size: 16px !important;
  font-weight: 600 !important;
  color: var(--cds-text-strong) !important;
}
:host ::ng-deep bfm-cash-flow-modal ::ng-deep .modal-container #record_type {
  gap: 26px !important;
}
:host {
  display: block;
  background: var(--cds-background-main);
  border-radius: 8px;
}
.cds-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--cds-primary-500);
  padding: 20px 24px;
  border-radius: 8px 8px 0 0;
}
.cds-modal-header .cds-icon-close {
  color: var(--cds-primary-contrast);
  cursor: pointer;
  padding: 16px;
}
.header-title {
  font-size: 24px;
  color: var(--cds-primary-contrast);
}
.close-button {
  background: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
}
/*# sourceMappingURL=modal-base.component.css.map */
